const steps = [
  {
    number: "01",
    title: "提交項目資訊",
    desc: "填寫上方表單，提供你的項目概況、進度與融資需求。整個過程只需 5 分鐘。",
    icon: "ri-file-text-line",
  },
  {
    number: "02",
    title: "7 天內審核回覆",
    desc: "我會親自閱讀每一份提交，並在 7 個工作天內給你明確回覆，不會讓你石沉大海。",
    icon: "ri-eye-line",
  },
  {
    number: "03",
    title: "優化材料並匿名介紹",
    desc: "若項目合適，我會協助你優化 Pitch 材料，並在保護你資料的前提下，匿名介紹給合適的投資人。",
    icon: "ri-briefcase-4-line",
  },
  {
    number: "04",
    title: "投資人感興趣 → 安排會議",
    desc: "一旦投資人對你的項目感興趣，我們將安排正式會議，讓雙方深入交流與評估。",
    icon: "ri-handshake-line",
  },
];

export default function HowItWorksSection() {
  return (
    <section id="how-it-works" className="py-24 bg-stone-950">
      <div className="max-w-6xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-amber-500 text-sm font-semibold tracking-widest uppercase mb-3">Process</p>
          <h2 className="text-4xl md:text-5xl font-bold text-white leading-tight" style={{ fontFamily: "'Noto Serif TC', serif" }}>
            合作流程
          </h2>
          <p className="text-white/50 text-base mt-4 max-w-md mx-auto">簡單、透明、有效率 —— 四個步驟，讓你的項目被對的人看見。</p>
        </div>

        {/* Steps */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {steps.map((step, i) => (
            <div key={i} className="relative flex flex-col">
              {/* Connector line (desktop only) */}
              {i < steps.length - 1 && (
                <div className="hidden lg:block absolute top-10 left-[calc(100%-12px)] w-full h-px border-t border-dashed border-white/15 z-0" />
              )}
              <div className="relative z-10 bg-stone-900 border border-stone-800 rounded-xl p-7 flex flex-col gap-5 h-full">
                <div className="flex items-center gap-3">
                  <span className="text-amber-600 font-black text-3xl leading-none">{step.number}</span>
                  <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-stone-800 text-amber-500">
                    <i className={`${step.icon} text-base`} />
                  </div>
                </div>
                <h3 className="text-white font-bold text-base">{step.title}</h3>
                <p className="text-stone-400 text-sm leading-relaxed">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Final CTA */}
        <div className="mt-14 text-center">
          <a
            href="#submit"
            className="inline-flex items-center gap-2 bg-amber-600 hover:bg-amber-500 text-white font-bold px-9 py-4 rounded-md text-base transition-colors whitespace-nowrap cursor-pointer"
          >
            <i className="ri-send-plane-line" />
            立即開始 — 提交你的AI項目
          </a>
          <p className="text-stone-600 text-xs mt-4">免費 · 無前期費用 · 7 天回覆保證</p>
        </div>
      </div>
    </section>
  );
}
